module.exports = __webpack_public_path__ + "static/media/eraser.b97aa8a2.svg";